import React, { useContext } from "react";
import { ContextType, FilterMetadataApiWithCountReturn, WaterProvider } from "../misc";

interface IProviderInfoPageContext {
    provider?: WaterProvider;
    metadata?: FilterMetadataApiWithCountReturn;
    loading?: boolean;
    contextType?: ContextType;
}

const defaultState = {
    provider: undefined,
    metadata: undefined,
    loading: true,
    contextType: undefined
};

export const ProviderInfoPageContext = React.createContext<IProviderInfoPageContext>(defaultState);
export const useProviderInfoPageContext = () => useContext(ProviderInfoPageContext);
